export default {
    list: {
        loadingText: '玩命加载中...',
        noMoreText: '没有更多了',
        emptyText: '暂无内容',
        loadMoreText: '加载更多',
    },
    modal: {
        cancelText: '取消',
        okText: '确定',
    },
    selectAngle: {
        title: '角度',
    },
};
